import { Injectable } from '@angular/core';
import { Events } from "ionic-angular";
import { ApiProvider } from '../api/api';
import { Socket, SocketIoConfig } from 'ngx-socket-io';
import moment from 'moment';
import 'moment-precise-range-plugin';
//import * as isNullOrEmpty from 'isnullorempty';

/**
 * The possible log levels.
 */
export enum LogLevel {
  Error,
  Warning,
  Info,
  Debug,
}

/*
0: 'Error'
1: 'Warning'
2: 'Info'
3: 'Debug'
*/

@Injectable()
export class LoggerProvider {

  private MOMENT_JS_FORMAT_FULL: string = 'DD.MM.YYYY HH:mm:ss.SSSS';
  private MOMENT_JS_FORMAT: string = 'DD.MM.YYYY HH:mm:ss';

  private debugging: boolean = false;
  private classes: any = {};
  
  private count: number = 0;
  private maxCount: number = 500;

  private uuid: string;

  private remoteLog: boolean;
  private localLog: boolean;

  private apiProvider: ApiProvider;

  private socket: Socket;

  public startTime: any;


  constructor(
    public events: Events,
  ) {
    console.log('LoggerProvider::logLevel', LogLevel);

    // 2019-03-23, global cron
    this.events.subscribe('cron:run', (background: boolean) => {
      this.runCron(background);
    });
  }

  private runCron(background: boolean): void {
    if (this.debugging) console.log('LoggerProvider::runCron', {background: background});

    if (background) {
      this.clear(true);
    }
  }

  public formatMoment(datetime: moment.Moment): any {
    return (datetime) ? datetime.format(this.MOMENT_JS_FORMAT) : datetime;
  }

  public setLogLevel(obj: any, loglevel: LogLevel): void {
    if (this.debugging) console.log('LoggerProvider::setLogLevel', {obj: obj, name: this.getName(obj), loglevel: loglevel});

    this.classes[this.getName(obj)] = loglevel;
  }

  public getLogLevel(obj: any): any {
    if (this.debugging) console.log('LoggerProvider::getLogLevel', {obj: obj, name: this.getName(obj)});

    return this.classes[this.getName(obj)];
  }

  /**
   * Logs messages or objects  with the debug level.
   * Works the same as console.log().
   */
  public debug(obj: any, ...objects: any[]) {
    this.log(console.log, LogLevel.Debug, objects, obj);
  }

  public debugLocal(obj: any, ...objects: any[]) {
    this.logLocal(console.log, LogLevel.Debug, objects, obj);
  }

  /**
   * Logs messages or objects  with the info level.
   * Works the same as console.info().
   */
  public info(obj: any, ...objects: any[]) {
    this.log(console.info, LogLevel.Info, objects, obj);
  }

  public infoLocal(obj: any, ...objects: any[]) {
    this.logLocal(console.info, LogLevel.Info, objects, obj);
  }

  /**
   * Logs messages or objects  with the warning level.
   * Works the same as console.warn().
   */
  public warn(obj: any, ...objects: any[]) {
    this.log(console.warn, LogLevel.Warning, objects, obj);
  }

  public warnLocal(obj: any, ...objects: any[]) {
    this.logLocal(console.warn, LogLevel.Warning, objects, obj);
  }

  /**
   * Logs messages or objects  with the error level.
   * Works the same as console.error().
   */
  public error(obj: any, ...objects: any[]) {
    this.log(console.error, LogLevel.Error, objects, obj);
  }

  public errorLocal(obj: any, ...objects: any[]) {
    this.logLocal(console.error, LogLevel.Error, objects, obj);
  }

  // SIA-26, 2019-02-11
  public clear(force: boolean = false): void {
    this._clear(force);
  }

  private _clear(force: boolean = false): void {
    if (
      this.count >= this.maxCount
      ||
      force
    ) {
      console.clear();

      this.count = 0;
    }
  }

  public setUUID(uuid: string): void {
    this.uuid = uuid;
  }

  public setRemoteLog(remoteLog: boolean): void {
    this.remoteLog = remoteLog;

    if (remoteLog) {
      this.startWebsocket();

    } else {
      this.stopWebsocket();
    }
  }

  public getRemoteLog(): boolean {
    return this.remoteLog;
  }

  public setLocalLog(localLog: boolean): void {
    this.localLog = localLog;

    /*if (remoteLog) {
      this.startWebsocket();

    } else {
      this.stopWebsocket();
    }*/
  }

  public getLocalLog(): boolean {
    return this.localLog;
  }

  public setApiProvider(apiProvider: ApiProvider): void {
    this.apiProvider = apiProvider;
  }

  private startWebsocket(): void {
    if (this.apiProvider && !this.socket) {
      console.log('LoggerProvider::startWebsocket', {apiProvider: this.apiProvider});

      let url: string = this.apiProvider.url;
      console.log('LoggerProvider::startWebsocket', {url: url});

      const config: SocketIoConfig = {url: url, options: {path: '/' + this.apiProvider.api_logger + 'socket.io/'}};
      this.socket = new Socket(config);
    }

  }

  private stopWebsocket(): void {
    if (this.socket) {
      this.socket.disconnect(true);
      this.socket = null;
    }
  }

  private getName(obj: any): string {
    if (obj && obj.log_label_main) {
      return obj.log_label_main;

    } else if (obj) {
      return obj.constructor.name;

    } else {
      return 'default';
    }
  }

  private logLocal(func: Function, level: LogLevel, objects: any[], obj: any) {
    let remoteLog = (this.remoteLog) ? true : false;
    this.remoteLog = false;

    this.log(func, level, objects, obj);

    this.remoteLog = remoteLog;
  }

  public getUptime(): any {
    const me = this;

    //let uptime: any = moment.duration(moment().diff(me.startTime)).humanize();
    let uptime: any = moment.preciseDiff(me.startTime, moment());

    return uptime;
  }

  private log(func: Function, level: LogLevel, objects: any[], obj: any) {
    const me = this;
    
    if (me.debugging) console.log('LoggerProvider::log:classname', {
      name: me.getName(obj),
      include: Object.keys(me.classes).includes(me.getName(obj)),
      level: level,
      loglevel: LogLevel,
      classes: me.classes
    });

    //if (!isNullOrEmpty.isNullOrEmpty(me.classes[me.getName(obj)])) {
    if (Object.keys(me.classes).includes(me.getName(obj))) {
      if (me.debugging) console.log('LoggerProvider::log:level', {
        name: me.getName(obj),
        level: level,
        loglevel: LogLevel,
        class: me.classes[me.getName(obj)]
      });

      if (!me.remoteLog && level <= me.classes[me.getName(obj)]) {
        // local log

        // SIA-26, 2019-02-11
        me.count++;

        let uptime: any = me.getUptime();

        let logObjects = [moment().format(me.MOMENT_JS_FORMAT_FULL), uptime, me.count, me.uuid, ...objects];

        func.apply(console, logObjects);

        // SIA-26, 2019-02-11
        me._clear();

      } else if (me.remoteLog && me.apiProvider) {

        if (me.socket && level <= me.classes[me.getName(obj)]) {
          // remote log

          let uptime: any = me.getUptime();

          // TODO: prevent RangeError: Maximum call stack size exceeded
          setTimeout(() => {
            // 2019-03-11, added clearing
            me._clear();

            if (me.socket) {
              // 2019-03-11, added try/catch
              try {
                me.count++;

                me.socket.emit('remotelog', {
                  level: level,
                  name: me.getName(obj),
                  date: moment().format(me.MOMENT_JS_FORMAT_FULL),
                  uptime: uptime,
                  count: me.count,
                  uuid: me.uuid,
                  data: objects
                });

              } catch (e) {

              }
            }
          });
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/logger/logger.ts